"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * @class PageSpinner
 * @desc Simple loading spinner implementation. Depends on prop will show loading spinner animation or children content.
 * Children content should be exception safe if no data available, because it will be evaluated regardless of loading
 * state (react limitation), also content should be wrapped in top-level element (div or span) (also react limitation).
 *
 * @param {string} [className]
 *     Custom class names
 * @param {string} [data-id="page-spinner"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {string} [modal]
 *     When true, the spinner displays centered on the page as a modal,with a page-blocking background.
 * @param {string} [small]
 *     When true, the spinner displays as a smaller size.
 *
 * @param {string} [defaultText]
 *     Text that shows if CSS rotations are not supported
 */
var PageSpinner = function PageSpinner(_ref) {
  var dataId = _ref["data-id"],
      className = _ref.className,
      children = _ref.children,
      modal = _ref.modal,
      small = _ref.small;

  var spinner = /*#__PURE__*/_react.default.createElement("div", {
    "data-id": dataId,
    className: (0, _classnames.default)("page-loader__box", className)
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    className: (0, _classnames.default)("page-loader", small ? "page-loader--small" : null),
    show: true
  })), children && /*#__PURE__*/_react.default.createElement("div", {
    className: "page-loader__text",
    "data-id": "".concat(dataId, "-text")
  }, children));

  if (modal) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "modal show"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-bg",
      "data-id": "modal-bg"
    }), spinner);
  } else {
    return spinner;
  }
};

PageSpinner.propTypes = {
  "data-id": _propTypes.default.string,
  modal: _propTypes.default.bool,
  show: _propTypes.default.bool.isRequired,
  className: _propTypes.default.string
};
PageSpinner.defaultProps = {
  "data-id": "page-spinner",
  modal: false,
  small: false
};
var _default = PageSpinner;
exports.default = _default;
module.exports = exports["default"];